import React, {useEffect, useState} from "react";
import {
    MISCELLANEOUS_DETAILS_CONSTANTS as Labels
} from "../../constants/LabelConstants";
import FormPageSection from "../../components/FormPageSection/FormPageSection";
import MemberDropdownMultiselect
    from "../../components/FormContent/MemberDropdownMultiselect/MemberDropdownMultiselect";
import TextAreaField from "../../components/FormContent/TextAreaField/TextAreaField";
import {Miscellaneous} from "../../model/Miscellaneous";
import {useAppSelector} from "../../../store/hooks";
import {familyMembersSelector} from "../../slices/EstateFlowChartSlice";
import {FamilyMembers, MemberType, Trustee} from "../../model/EstateFlowchartTypes";
import {evaluateDropdownMemberId, isCustomMember, parseFamilyMembers} from "../../utils/DefUtils";

interface MiscellaneousDetailsSectionProps {
    estateItem: Miscellaneous;
    updateEstateItem: (estateItem: Miscellaneous) => void;
}

function MiscellaneousDetailsSection({
                                         estateItem,
                                         updateEstateItem
                                     }: Readonly<MiscellaneousDetailsSectionProps>) {

    const rawFamilyMembers = useAppSelector(familyMembersSelector);
    const [parsedFamilyMembers, setParsedFamilyMembers] = useState<FamilyMembers>({
        value: "",
        label: "",
        familyMember: []
    });

    useEffect(() => {
        buildFamilyMemberDropdownItems();
    }, [rawFamilyMembers]);

    const buildFamilyMemberDropdownItems = () => {
        const parsedFamilyMembersResponse: FamilyMembers = parseFamilyMembers(rawFamilyMembers);
        let item = {
            label: parsedFamilyMembersResponse.label,
            value: parsedFamilyMembersResponse.value,
            selected: false
        };
        parsedFamilyMembersResponse.familyMember.push(item);
        setParsedFamilyMembers(parsedFamilyMembersResponse);
    }

    const onChangeDropdown = (selectedOptions: any, type: MemberType) => {
        const members: Trustee[] = [];
        for (const element of selectedOptions) {
            const member: Trustee = {
                trustId: estateItem.trustId,
                memberType: type,
                familyMember: !isCustomMember(element.value, parsedFamilyMembers),
                customName: isCustomMember(element.value, parsedFamilyMembers) ? element.label : "",
                memberId: evaluateDropdownMemberId(element, parsedFamilyMembers),
            };
            members.push(member);
        }

        const newBeneficiaries = {...estateItem, beneficiaries: members};
        updateEstateItem(newBeneficiaries);
    }

    return (
        <FormPageSection id={"miscellaneous-details-section"}
                         headerText={Labels.MISCELLANEOUS_DETAILS_SECTION_LABEL_TEXT}
                         showRequiredLabel={false}>
            <MemberDropdownMultiselect
                label="Beneficiaries"
                required={false}
                options={rawFamilyMembers}
                selectedOptions={estateItem.beneficiaries}
                includeNT={false}
                useTags={true}
                helperText='Add a new name, if it is not in the list.'
                onChange={(options: any) => onChangeDropdown(options, MemberType.Beneficiary)}
            />
            <TextAreaField
                input={estateItem.funding}
                label={Labels.FUNDING_LABEL_TEXT}
                subText={Labels.FUNDING_SUB_TEXT}
                onChange={(funding) => updateEstateItem({
                    ...estateItem,
                    funding
                })}/>
            <TextAreaField
                label={Labels.ADDITIONAL_DETAILS_TEXT}
                input={('additionalDetails' in estateItem ? estateItem.additionalDetails : '')}
                subText={""}
                onChange={(additionalDetails) => {
                    updateEstateItem({
                        ...estateItem,
                        additionalDetails
                    })
                }}
            />
        </FormPageSection>
    );
}

export default MiscellaneousDetailsSection;